import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { ICardData, IDataOptional, IDataPersonal, IPages, IPlan } from "..";
import Button from "../../../components/Button";
import IconButton from "../../../components/IconButton";
import Input from "../../../components/Input";
import { toastError } from "../../../components/Toast";
import useAuthData from "../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../icons";
import { remask, unRemask } from "../../../libs/remask-mask";
import { serviceUsers } from "../../Collaborator/service";
import { MonthPlan, YearPlan } from "../Plans";
import {
  createClientGatewayPay,
  getClientGatewayPay,
  getSystemCost,
  getIpClient,
  createSubscriptionGatewayPay,
  getUsersActiveThisMonth,
  getValuePlans,
  valueByUser,
} from "../service";

export const VerefyData = ({
  plan,
  setPlan,
  setPage,
  dataPersonal,
  dataOptional,
}: {
  plan: IPlan;
  setPlan: Dispatch<SetStateAction<IPlan>>;
  setPage: Dispatch<SetStateAction<IPages>>;
  dataPersonal: IDataPersonal;
  dataOptional: IDataOptional;
}) => {
  const { token } = useAuthData();
  const [data, setData] = useState({ userActive: undefined, valuePlan: undefined });
  useEffect(() => {
    catchValuesData();
  }, []);

  async function catchValuesData() {
    const userActive = await getUsersActiveThisMonth(token);
    const valuePlan = await valueByUser(plan, token);
    setData({ userActive, valuePlan });
  }

  const back = () => setPage("DataPersonal");
  return (
    <>
      <Toaster />
      <div className="box-form">
        <div className="mt-8 flex items-center w-full justify-center">
          <IconButton icon={IconLeftArrowVersion2} className="" onClick={back} />
          <span className="text-2rem">Revise os dados, por favor! </span>
        </div>
        <div className="flex flex-col w-full">
          <p className="mx-6 my-8 text-4xl font-semibold">Dados Pessoais</p>
          <div className="flex flex-col w-full">
            <div className="box-row">
              <Input name="name" label="Nome do Titular" placeholder="" value={dataPersonal?.name} disabled />
            </div>
            <div className="box-row">
              <Input name="email" label="E-mail do Titular" placeholder="" value={dataPersonal?.email} disabled />
              <Input name="cpfCnpj" label="CPF ou CNPJ do Titular" placeholder="" value={dataPersonal?.cpfCnpj} disabled />
            </div>
            <div className="box-row">
              <Input
                name="phone"
                label="Telefone do Titular"
                placeholder=""
                value={remask(dataPersonal?.phone, unRemask(dataPersonal?.phone)?.length > 10 ? ["(99) 99999-9999"] : ["(99) 9999-9999"])}
                disabled
              />
              <Input name="postalCode" label="CEP" placeholder="" value={dataPersonal?.postalCode} disabled />
              <Input name="street" label="Logadouro" placeholder="" value={dataOptional?.street} disabled />
              <Input name="district" label="Bairro" placeholder="" value={dataOptional?.district} disabled />
            </div>
            <div className="box-row">
              <Input name="addressNumber" label="Nº do Endereço" placeholder="" value={dataPersonal?.addressNumber} disabled />
              <Input name="complement" label="Complemento" placeholder="" value={dataPersonal?.complement || "Sem complemento"} disabled />
              <Input name="city" label="Cidade" placeholder="" value={dataOptional?.city} disabled />
              <Input name="state" label="Estado" placeholder="" value={dataOptional?.state} disabled />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-center items-center p-10 gap-10">
          <div className="w-3/6">
            <p className="text-2rem w-full text-center">Plano Escolhido</p>
            {plan === "Month" ? (
              <MonthPlan setPlan={setPlan} setPage={setPage} button={false} />
            ) : (
              <YearPlan setPlan={setPlan} setPage={setPage} button={false} />
            )}
          </div>
          <div className="flex flex-col items-center gap-5">
            <p className="flex items-end flex-row text-2xl">
              Até o momento, você tem <strong className="flex mx-2 text-3xl">{data?.userActive}</strong> usuários ativos. O valor a pagar será de R$
              <strong className="mx-2 text-3xl">{data?.valuePlan}</strong> mensais
            </p>
          </div>
        </div>
        <div className="flex justify-center gap-4 w-full mb-5">
          <Button className="bg-blue-100 border-primary text-primary" onClick={back}>
            Cancelar
          </Button>
          <Button className="bg-primary" onClick={() => setPage("Card")}>
            Próximo
          </Button>
        </div>
      </div>
    </>
  );
};
